module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "mobileIconHeader.3251a466.jpg";